import React from 'react';
import { severityFromPct, TPL_SEVERITY_STYLE } from '../../services/tplSeverityStyles';
import { shouldShowCount } from '../../services/tplSeverityStyles';

export interface LayerLeaderRow {
  userId: string;
  name: string;
  disciplinaPct: number;
  conformidadePct: number;
  perdas: number;
  isSelf?: boolean;
}

interface DataflowLayerLeaderboardProps {
  rows: LayerLeaderRow[];
  emptyLabel?: string;
}

/** Leaderboard executivo — quem sustenta o sistema. */
export const DataflowLayerLeaderboard: React.FC<DataflowLayerLeaderboardProps> = ({
  rows,
  emptyLabel = 'Nenhum líder no escopo.',
}) => {
  const sorted = [...rows].sort((a, b) => b.disciplinaPct - a.disciplinaPct);

  if (sorted.length === 0) {
    return <p className="py-8 text-center text-[11px] text-slate-400">{emptyLabel}</p>;
  }

  return (
    <ol className="space-y-1.5">
      {sorted.map((row, i) => {
        const tone = severityFromPct(row.disciplinaPct);
        const style = TPL_SEVERITY_STYLE[tone];
        return (
          <li
            key={row.userId}
            className={`rounded-lg border px-3 py-2 ${style.border} ${i === 0 ? style.bg : 'bg-white dark:bg-slate-950/30'}`}
          >
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className="min-w-0">
                <p className="text-[11px] font-bold uppercase tracking-wide text-slate-800 dark:text-slate-100">
                  {i + 1}. {row.name}
                  {row.isSelf && (
                    <span className="ml-1 text-[9px] font-semibold normal-case text-slate-400">(você)</span>
                  )}
                </p>
                <div className="mt-1 flex flex-wrap gap-x-3 gap-y-0.5 text-[10px] tabular-nums">
                  <span>
                    Disciplina:{' '}
                    <strong className={style.accent}>{row.disciplinaPct}%</strong>
                  </span>
                  <span>
                    Conformidade:{' '}
                    <strong className="text-slate-700 dark:text-slate-200">{row.conformidadePct}%</strong>
                  </span>
                  {shouldShowCount(row.perdas) && (
                    <span>
                      Perdas: <strong className="text-red-600">{row.perdas}</strong>
                    </span>
                  )}
                </div>
              </div>
              {i === 0 && row.disciplinaPct >= 85 && (
                <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[8px] font-bold uppercase text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300">
                  Referência
                </span>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default DataflowLayerLeaderboard;
